module.exports = __webpack_public_path__ + "assets/stomach.13ab0825.svg";